
















import { computed, defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { TabField } from "@/types";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "TabsHeader",
  components: { SiteLogo },
  props: {
    tabs: { type: Array as () => TabField[], required: true },
    active: { type: String },
  },
  setup() {
    const { authUser } = useAuthUser();
    const attrName = computed(() => (authUser.value ? "" : "href"));
    return { attrName };
  },
});
